export default __webpack_public_path__ + "static/leaguespartan-bold-508a4f7f19b2c3a927d0b1dbbe6dc9ea.woff";